import React from 'react';
import queryString from 'query-string'; // N.B. this needs to be an older version that supports CommonJS imports
import { systemText } from '../../helpers/string';

export const Error = ({ history }) => {
	const { error } = queryString.parse(history.location.search);

	const text = {
		defaultError: systemText('ErrorPage/DefaultError'),
		back: systemText('ErrorPage/Back'),
	};

	text.defaultError =
		text.defaultError === 'ErrorPage/DefaultError' ? 'Oh dear. Looks like something has gone wrong.' : text.defaultError;
	text.back = text.back === 'ErrorPage/Back' ? 'Back to home' : text.defaultError;

	return (
		<div className="login-box">
			<div className="login-logo">
				<img alt="Richardson Sales Performance" src="/dist/img/richardson_sp.png" loading="lazy" />
			</div>
			<div className="login-body" data-testid="error-page-details">
				<p className="error">{error || text.defaultError}</p>
				<div className="mt20">
					<a href="/" className="btn btn-primary">
						<i className="fa fa-arrow-left mr5" />
						{text.back || 'Back to home'}
					</a>
				</div>
			</div>
		</div>
	);
};

export default Error;
